// Module
var code = "<textarea ui-scroll class=\"oc-comment\" rows=\"{{rows}}\" ng-required=\"ngRequired\" maxlength=\"{{maxLength}}\" ng-disabled=\"ngDisabled\" ng-model=\"ngModel\"></textarea> <div ng-if=\"!ngDisabled\">{{'common.remainingCharacters' | xlat}}: {{remainingCharacters}}</div>";
// Exports
module.exports = code;